export const form = {
  email: {
    label: 'Електронна пошта',
    placeholder: 'Введіть адресу пошти'
  },
  name: {
    label: 'Назва',
    placeholder: 'Введіть назву'
  },
  clubName: {
    label: 'Назва клубу',
    placeholder: 'Введіть назву клубу',
    description: 'Введіть назву латиною'
  },
  address: {
    label: 'Адреса',
    placeholder: 'Введіть адресу'
  },
  workPeriod: {
    start: {
      placeholder: 'Початок роботи'
    },
    end: {
      placeholder: 'Кінець роботи'
    }
  },
  workTime: {
    start: {
      label: 'Час відкриття'
    },
    end: {
      label: 'Час закриття'
    }
  },
  country: {
    label: 'Вкажіть розташування клубу',
    placeholder: 'Вкажіть розташування клубу'
  },
  role: {
    label: 'Вакансії в клубі'
  },
  currency: {
    label: 'Вкажіть валюту виплат Артистам',
    placeholder: 'Вкажіть валюту виплат Артистам'
  },
  nativeLanguage: {
    label: 'Рідна мова',
    placeholder: 'Вкажіть свою рідну мову'
  },
  lastName: {
    label: 'Прізвище',
    placeholder: 'Введіть своє прізвище'
  },
  birth: {
    label: 'Дата народження',
    placeholder: 'Введіть дату народження'
  },
  password: {
    label: 'Пароль',
    placeholder: 'Введіть пароль',
    description:
      'Пароль повинен містити щонайменше 8 символів верхнього та нижнього реєстру, цифр та спеціальних символів (наприклад,!, @, #, $)'
  },
  resetPassword: {
    new: {
      label: 'Новий пароль',
      placeholder: 'Введіть новий пароль'
    },
    confirm: {
      label: 'Підтвердьте пароль',
      placeholder: 'Введіть новий пароль'
    }
  },
  penalties: {
    placeholder: 'Введіть назву штрафу'
  },
  phone: {
    label: 'Номер телефону',
    placeholder: '+373-000-00-00'
  },
  buttons: {
    continue: 'Продовжувати',
    login: 'Вхід',
    send: 'Надсилати',
    cancel: 'Скасувати',
    confirm: 'Підтверджувати',
    resend: 'Відправити ще раз',
    register: 'Реєстрація',
    registerRequest: 'Залиште заяву на реєстрацію'
  },
  links: {
    forgotPasswordLink: 'Забули пароль?',
    login: 'Увійти',
    haveAccount: 'У мене вже є рахунок',
    privacy: 'Угода користувача та політика конфіденційності.'
  },
  other: {
    or: 'Або'
  },
  approximateStartDate: {
    label: 'Орієнтовна дата роботи'
  },
  approximateEndDate: {
    label: 'Приблизну дату закінчення роботи'
  },
  search: {
    placeholder: 'Обшук',
    placeholderCitizienship: 'Пошук громадянства'
  },
  positionItem: {
    label: 'Введіть позицію'
  },
  paymentFrequency: {
    label: 'Частота платежів'
  },
  price: {
    label: 'Ціна'
  },
  priceForArtist: {
    label: 'Сума для Артиста'
  },
  artistPercent: {
    label: 'Відсоток для Артиста'
  }
};
